import { DynamicQuestionFieldTypes } from './constants'
import { DynamicQuestionsSteps } from './types'

export const QuestionMapping: DynamicQuestionsSteps = {
  yourCompany: {
    qCompanyProductsOrServices: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qCompanyProductDeliveryMethod: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
      helpText: true,
    },
    qTypesOfClientsServiceIsOfferedTo: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
  },
  jurisdiction: {
    qAnyExposureToBvnkProhibitedJurisdictions: {
      type: DynamicQuestionFieldTypes.RADIO,
      customLabel: true,
    },
    qMainMarketsCompanyTradesIn: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qPreventingOperationInLicenseRequiredJurisdictions: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qJurisdictionAccessControls: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
      helpText: true,
    },
  },
  regulation: {
    qPastRegulatoryActionsOrPenalties: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
    qUnderRegulatoryInspection: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
  },
  moneyLaundering: {
    qIndependentMlro: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qMlroExperienceYears: {
      type: DynamicQuestionFieldTypes.NUMBER,
    },
    qPeriodicAmlAssessment: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
    qNumberOfFteStuff: {
      type: DynamicQuestionFieldTypes.NUMBER,
    },
    qComplianceMatterContact: {
      type: DynamicQuestionFieldTypes.CONTACT,
    },
  },
  marketing: {
    qMarketedProductsAndServices: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qPerformsColdCalling: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
  },
  customerScreeningAndKyc: {
    qSanctionScreeningStage: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qKycImplementationStages: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qConductsExistingCustomerKycReviews: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qConductsEddForVips: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qHasMinorAccessControls: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qClientTypes: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
  },
  appropriatenessAssessment: {
    qAppropriatenessAssessmentProcess: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
      helpText: true,
    },
    qAssessmentMethodsAndCriteria: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qAssessmentFailureRate: {
      type: DynamicQuestionFieldTypes.NUMBER,
    },
    qActionsForAssessmentFailure: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
  },
  trading: {
    qOffersInvestmentAdvice: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
    qCfdRiskEducationMethods: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qHasClientLossControls: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qHasBestExecutionPolicy: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
  },
  suspiciousTransactionsCrypto: {
    qCleanAssetsPurchase: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qPreventMarketManipulationOrInsideTrading: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
  },
  suspiciousTransactionsGamingAndFinancialServices: {
    qAcceptsCashTransactions: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qAllowsPeerToPeerTransfers: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qPermitsCrossBorderGambling: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qMonitorsTransactionVelocityAndStructuring: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qDepositAndWithdrawalLimits: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
  },
  customerAssets: {
    qUsesCustodySolutions: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
    qUtilizesHotColdWallets: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qWalletDistributionAndSecurityMeasures: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qSegregationOfClientFunds: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
  },
  securityTechnologies: {
    qPrivacyProtocolSupport: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qIpCapture: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qVpnDetectionAndManagement: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
  },
  cryptoComponents: {
    qFacilitateCryptoCurrency: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qFacilitateUnlicensedCryptoTokens: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qSupportIco: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qCoinAcceptancePolicy: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qBlockchainMonitoringTool: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
    qRealTimeMonitoringForSuspiciousTransactions: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
  },
  travelRule: {
    qTravelRuleInForce: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
    qProviderForCompliantDataSharing: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
      helpText: true,
    },
  },
  responsibleGaming: {
    qAdoptsResponsibleGamblingFramework: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qProblematicGamblingMonitoringMethods: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qVulnerablePlayerProtectionMeasures: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qProvidesSelfExclusionTool: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
  },
  policies: {
    qClientFundsSecurityMeasures: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
    qMaintainsClientFundSegregation: {
      type: DynamicQuestionFieldTypes.RADIO,
    },
    qHasCodeOfConductPolicy: {
      type: DynamicQuestionFieldTypes.RADIO,
      additionalQuestion: true,
    },
    qMarketManipulationPreventionMeasures: {
      type: DynamicQuestionFieldTypes.TEXTAREA,
    },
  },
}

export const MappedQuestionCodes = Object.values(QuestionMapping)?.flatMap(Object.keys)
